<template>
  <div>
    <a-button
      type="primary"
      :style="{ margin: '0 0 24px 0' }"
      v-on:click="topage('/home/tokenPackage/tokenPackageAdd')"
    >
      新增
    </a-button>
    <a-button type="danger" :style="{ margin: '0 0 24px 0' }" v-on:click="dels">
      批量删除
    </a-button>
    <a-table
      :columns="columns"
      :row-key="(record) => record.objId"
      :data-source="data"
      :pagination="pagination"
      :loading="loading"
      @change="handleTableChange"
      :row-selection="rowSelection"
    >
      <template slot="img" slot-scope="name">
        <img :src="name" alt="" />
      </template>
      <a-avatar slot="avatar" icon="user" />
      <span slot="memberStatus" slot-scope="text, record">
        <a-switch
          checked-children="上架"
          un-checked-children="下架"
          :checked="record.shelf === true ? true : false"
          @change="onChange(record)"
        />
      </span>
         <template slot="limited1" slot-scope="text">
        <span> {{ text == 0 ? "不限购" : text == 1 ? "限购一份" : "" }} </span>
      </template>
      <template slot="operate" slot-scope="text, operate">
        <a
          v-on:click="
            topage(`/home/tokenPackage/tokenPackageEdit?objId=${operate.objId}`)
          "
          @click="edit"
          >编辑</a
        >
        <a v-on:click.prevent="del(operate)">删除</a>
      </template>
    </a-table>
  </div>
</template>
<script>
import {
  getTokensList,
  delTokensList,
  delsTokensList,
  getSeachList,
  storeUpdown,
} from "@/api/storeApi.js";
import { message } from "ant-design-vue";
const columns = [
  {
    title: "编号",
    dataIndex: "objId",
    align: "center",
    sorter: true,
  },
  {
    title: "商品名称",
    align: "center",
    dataIndex: "name",
  },
  {
    title: "封面图",
    dataIndex: "img",
    align: "center",
    scopedSlots: { customRender: "img" },
  },
  {
    title: "所属门店",
    dataIndex: "shopName",
    align: "center",
  },
  {
    title: "上下架",
    align: "center",
    dataIndex: "name",
    scopedSlots: { customRender: "memberStatus" },
  },
  {
    title: "门市价",
    dataIndex: "priceShop",
    align: "center",
  },
  {
    title: "支付价",
    align: "center",
    dataIndex: "minSpecPrice",
    scopedSlots: { customRender: "name" },
  },
   {
    title: "限购",
    dataIndex: "limited",
    align: "center",
    scopedSlots: { customRender: "limited1" },
  },
  {
    title: "显示序号",
    align: "center",
    dataIndex: "sortNum",
    scopedSlots: { customRender: "sortNum" },
  },
  {
    title: "创建时间",
    dataIndex: "createTime",
    align: "center",
  },
  {
    title: "操作",
    dataIndex: "name",
    scopedSlots: { customRender: "operate" },
  },
];

export default {
  data() {
    return {
      data: [],
      ids: [],
      pagination: {
        current: 1,
        total: 0,
        showSizeChanger: true,
        pageSizeOptions: ["10", "20", "40", "80", "100"],
        showTotal: (total) => `共 ${total} 条`,
        pageSize: 10,
      },
      loading: false,
      columns,
      visible: false,
    };
  },
  mounted() {
    this.getTokensListData();
  },
  computed: {
    rowSelection() {
      return {
        onChange: (selectedRowKeys, selectedRows) => {
          this.$store.commit("setidList", selectedRowKeys);
          console.log(`selectedRowKeys: ${selectedRowKeys}`);
        },
      };
    },
  },
  props: ["formInline"],
  methods: {
    topage(routerpath) {
      this.$router.push(routerpath);
    },
    // 编辑
    edit() {},
    // 分页按钮
    handleTableChange(pagination, filters, sorter) {
      console.log(pagination);
      this.loading = true;
      this.pagination.current = pagination.current; //重置当前页
      getTokensList(10, this.pagination.current, 653, 654).then((res) => {
        this.data = res.data;
      });
      this.loading = false;
    },
    query() {
      this.loading = true;
      getSeachList(
        this.formInline.limit,
        this.formInline.page,
        653,
        654,
        this.formInline.name
      ).then((res) => {
        this.loading = false;
        this.data = res.data;
        this.pagination.total = res.count;
      });
    },
    // 分页数据
    getTokensListData() {
      this.loading = true;
      getTokensList(10, 1, 653, 654).then((res) => {
        this.loading = false;
        this.pagination.total = res.count;
        this.data = res.data;
      });
    },
    //
    onChange(row) {
      console.log(row);
      storeUpdown(row.objId, true).then(() => {
        this.getTokensListData();
        message.success(res.info);
      });
    },
    //
    del(row) {
      console.log(row);
      this.loading = true;
      delTokensList([row.objId]).then((res) => {
        message.success("删除成功");
        this.getTokensListData();
        this.loading = false;
      });
    },
    dels() {
      this.loading = true;
      let idList = this.$store.state.idList;
      delsTokensList(idList).then((res) => {
        this.loading = false;
        this.getTokensListData();
      });
    },
    showModal() {
      this.visible = true;
    },
    handleOk(e) {
      console.log(e);
      this.visible = false;
    },
  },
};
</script>
<style scoped>
img {
  width: 110px;
  height: 50px;
}
</style>



// WEBPACK FOOTER //
// src/views/marketingManagement/tokenPackage/tokenPackageHomeContent.vue